/**
 * Created by mqamhieh on 6/27/16.
 */
/**
 * @namespace JarEventEmitter
 *
 * @constructor
 */
window.JarEventEmitter = function () {

    var self = this;

    var handlers = {};

    /**
     * Attach new event to this emitter
     *
     * @param eventName
     * @param handler
     * @return {{event: *, index: number}}
     */
    self.on = function (eventName, handler) {
        handlers[eventName] = handlers[eventName] || [];
        var handlerIndex = handlers[eventName].push(handler) - 1;
        return {event: eventName, index: handlerIndex};
    };

    /**
     * @name JarEventEmitter#off
     * @param handlerInfo
     * @return {JarEventEmitter}
     */
    self.off = function (handlerInfo) {
        if (handlerInfo && handlers[handlerInfo.event] && handlers[handlerInfo.event][handlerInfo.index]) {
            delete handlers[handlerInfo.event][handlerInfo.index];
        }

        return self;
    };

    /**
     * Off all handlers on event emitter
     */
    self.offAll = function () {
        handlers = {};

        return self;
    };

    return {
        trigger: function (eventName, param1, param2, param3, param4, param5) {
            if (handlers[eventName]) {
                handlers[eventName].forEach(function (handler) {
                    if (handler) {
                        setTimeout(function () {
                            handler(param1, param2, param3, param4, param5);
                        }, 1);
                    }
                });
            }
        },
        triggerSync: function (eventName, param1, param2, param3, param4, param5) {
            if (handlers[eventName]) {
                for (var i in handlers[eventName]) {

                    var handler = handlers[eventName][i];

                    if (handler) {
                        handler(param1, param2, param3, param4, param5);
                    }
                }
            }
        }
    };
};